const crearAlerta = {
  'Crear alerta de nuevos trabajos': 'Crear alerta de nuevos trabajos',
  '¿Querés recibir las nuevas ofertas de esta búsqueda por email? ¡Creá una alerta!':
    '¿Quieres recibir las nuevas ofertas de esta búsqueda por email? ¡Crea una alerta!',
  'Crear alerta': 'Crear alerta',
}

export default crearAlerta
